<template>
  <ExternalQueryList
      headline="Content Colors"
      endpoint="/api/v2/content-colors"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentColor => $router.push(getUrl(contentColor))"
  >
    <template v-slot:default="{ row: contentColor }">
      <td>
        <router-link :to="getUrl(contentColor)">
          {{ contentColor.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ contentColor.attributes.hex }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/colors/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Hex'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentColor) {
      return '/portals/' + this.portal.id + '/content/colors/' + contentColor.id + '/edit'
    }
  }
}
</script>
